import { render, staticRenderFns } from "./SpecificationsVideo.vue?vue&type=template&id=521640dc"
import script from "./SpecificationsVideo.vue?vue&type=script&lang=js"
export * from "./SpecificationsVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports